export function formatRejectionObservation(observation?: string | null): string {
  return (
    observation?.replace(/\\r\\n|\\r|\\n|\r\n?|\n/g, '\n').trim() ||
    'Sem observação informada.'
  );
}
